module.exports = __webpack_public_path__ + "img/camara-circle.c2a9a609.svg";